import { Box, Typography } from "@mui/material";
import { WelcomeHeader } from "./PortalUI";

export default function AuthenticatedHero({
  industry,
  theme,
  shell,
  displayName
}) {
  if (industry === "government") {
    return <Box sx={{
      background: `linear-gradient(135deg, ${theme.primary}, #334155)`,
      padding: { xs: "16px 14px", sm: "28px 32px", md: "40px 50px" },
      color: "#fff",
      borderRadius: { xs: "12px", md: theme.borderRadius },
      boxShadow: "0 10px 25px rgba(30,58,138,0.15)",
      marginBottom: { xs: 2, md: 3.75 },
    }}>
      <Box sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: 1,
        background: "rgba(255,255,255,0.12)",
        padding: "6px 14px",
        borderRadius: "30px",
        fontSize: { xs: 11, sm: 12 },
        fontWeight: 700,
        marginBottom: { xs: 1.5, md: 2 },
      }}>
        <span>{shell.heroBadge.icon}</span> {shell.heroBadge.text}
      </Box>
      <Typography variant="h3" sx={{
        fontSize: { xs: "1.35rem", sm: "1.75rem", md: "2.2rem" },
        fontWeight: 900,
        margin: 0,
        lineHeight: 1.2,
        fontFamily: "serif",
      }}>
        {shell.heroTitle}
      </Typography>
      <Box sx={{
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        justifyContent: "space-between",
        alignItems: { xs: "flex-start", sm: "center" },
        marginTop: { xs: 1.5, md: 2.5 },
        gap: 1.5,
      }}>
        <Typography variant="body2" sx={{ fontSize: { xs: 13, sm: 14 }, opacity: 0.85, margin: 0, wordBreak: "break-word" }}>
          Authenticated Citizen: <strong>{displayName}</strong>
        </Typography>
        <Box sx={{
          display: "inline-flex",
          alignItems: "center",
          gap: 0.75,
          background: "rgba(255,255,255,0.15)",
          padding: { xs: "6px 12px", sm: "8px 16px" },
          borderRadius: "8px",
          fontSize: { xs: 11, sm: 12 },
          fontWeight: 700,
        }}>
          🔒 Biometric Access Level 3 Active
        </Box>
      </Box>
    </Box>;
  }
  if (industry === "healthcare") {
    return <Box sx={{
      background: `linear-gradient(135deg, ${theme.primary}, ${theme.accent})`,
      padding: { xs: "16px 14px", sm: "28px 32px", md: "40px 50px" },
      color: "#fff",
      borderRadius: { xs: "12px", md: theme.borderRadius },
      marginBottom: { xs: 2, md: 3.75 },
      display: "flex",
      flexDirection: { xs: "column", md: "row" },
      justifyContent: "space-between",
      alignItems: { xs: "stretch", md: "center" },
      gap: { xs: 2, md: 3 },
    }}>
      <Box sx={{ minWidth: 0 }}>
        <Box sx={{
          display: "inline-flex",
          alignItems: "center",
          gap: 1,
          background: "rgba(255,255,255,0.2)",
          padding: "4px 12px",
          borderRadius: "30px",
          fontSize: { xs: 11, sm: 12 },
          fontWeight: 700,
          marginBottom: 1.5,
        }}>
          <span>{shell.heroBadge.icon}</span> {shell.heroBadge.text}
        </Box>
        <Typography variant="h3" sx={{
          fontSize: { xs: "1.35rem", sm: "1.75rem", md: "32px" },
          fontWeight: 800,
          margin: 0,
          lineHeight: 1.2,
        }}>Welcome, {displayName}</Typography>
        <Typography variant="body2" sx={{
          opacity: 0.85,
          fontSize: { xs: 12, sm: 14 },
          marginTop: 0.5,
        }}>{shell.welcomeSubtitle}</Typography>
      </Box>
      <Box sx={{
        background: "rgba(255,255,255,0.15)",
        padding: { xs: "12px 16px", sm: "16px 24px" },
        borderRadius: "16px",
        border: "1px solid rgba(255,255,255,0.2)",
        flexShrink: 0,
        width: { xs: "100%", md: "auto" },
      }}>
        <Box sx={{ fontSize: 12, opacity: 0.8, fontWeight: 700 }}>LegitimatelyU Health Record Token</Box>
        <Box sx={{ fontSize: { xs: 14, sm: 15 }, fontWeight: 800, marginTop: 0.25 }}>#LU-HLTH-9028-XX1</Box>
      </Box>
    </Box>;
  }
  if (industry === "insurance") {
    return <Box sx={{
      background: "#fff7ed",
      borderBottom: `2.5px solid ${theme.primary}22`,
      padding: { xs: "16px 14px", sm: "24px 28px", md: "30px 40px" },
      borderRadius: { xs: "12px", md: theme.borderRadius },
      marginBottom: { xs: 2, md: 3.75 },
    }}>
      <Box sx={{
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        justifyContent: "space-between",
        alignItems: { xs: "flex-start", sm: "center" },
        gap: 2,
      }}>
        <Box sx={{ minWidth: 0 }}>
          <Typography component="span" sx={{ fontSize: { xs: 22, sm: 28 } }}>{shell.icon}</Typography>
          <Typography variant="h3" sx={{
            fontSize: { xs: "1.25rem", sm: "1.65rem", md: "26px" },
            fontWeight: 900,
            color: theme.text,
            mt: 1,
            mb: 0,
            lineHeight: 1.2,
          }}>
            SureGuard Customer Portal
          </Typography>
          <Typography variant="body2" sx={{
            fontSize: { xs: 12, sm: 14 },
            color: theme.text,
            opacity: 0.7,
            mt: 0.5,
            wordBreak: "break-word",
          }}>
            Policyholder: {displayName} • Cryptographic Identity Active
          </Typography>
        </Box>
        <Box sx={{
          background: "#fff",
          border: `1.5px solid ${theme.primary}44`,
          padding: { xs: "10px 16px", sm: "12px 24px" },
          borderRadius: "12px",
          flexShrink: 0,
          width: { xs: "100%", sm: "auto" },
        }}>
          <Box sx={{ fontSize: 11, color: "#64748b", fontWeight: 700 }}>Security Status</Box>
          <Box sx={{ fontSize: { xs: 13, sm: 14 }, fontWeight: 800, color: "#10b981", mt: 0.25 }}>
            ✓ LU Signature Secured
          </Box>
        </Box>
      </Box>
    </Box>;
  }
  if (industry === "corporate") {
    return <Box sx={{
      borderBottom: "1px solid rgba(99,102,241,0.2)",
      padding: { xs: "16px 14px", sm: "24px 32px", md: "30px 40px" },
      background: "rgba(2,6,23,0.8)",
      borderRadius: { xs: "12px", md: theme.borderRadius },
      marginBottom: { xs: 2, md: 3.75 },
    }}>
      <Box sx={{
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        justifyContent: "space-between",
        alignItems: { xs: "flex-start", sm: "center" },
        gap: 2,
      }}>
        <Box sx={{ minWidth: 0 }}>
          <Typography component="span" sx={{
            background: "linear-gradient(135deg, #6366f1, #a855f7)",
            color: "#fff",
            padding: "4px 10px",
            borderRadius: "4px",
            fontSize: { xs: 10, sm: 11 },
            fontWeight: 900,
          }}>ENTERPRISE PORTAL</Typography>
          <Typography variant="h3" sx={{
            fontSize: { xs: "1.25rem", sm: "1.65rem", md: "28px" },
            fontWeight: 900,
            color: "#fff",
            marginTop: 1,
            letterSpacing: "-0.5px",
            marginBottom: 0,
            lineHeight: 1.2,
          }}>
            EnterpriseHub SSO Launchpad
          </Typography>
        </Box>
        <Box sx={{ textAlign: { xs: "left", sm: "right" }, flexShrink: 0 }}>
          <Box sx={{ fontSize: { xs: 11, sm: 12 }, color: "#6366f1", fontWeight: 700 }}>Biometric SSO active</Box>
          <Box sx={{ fontSize: { xs: 13, sm: 14 }, fontWeight: 800, color: "#10b981", marginTop: 0.25 }}>✓ Session Trusted</Box>
        </Box>
      </Box>
    </Box>;
  }
  return <WelcomeHeader displayName={displayName} subtitle={shell.welcomeSubtitle} themeColors={theme} />;
}
